<template>
  <a href="/df/#form">
    <custom-button :is-white="isWhite">Долучитись</custom-button>
  </a>
</template>

<script>
import CustomButton from "@/components/UI/CustomButton.vue";

export default {
  name: "custom-button-join",
  components: { CustomButton },
  props: {
    isWhite: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style lang="scss" scoped></style>
